<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/ITS_contents">Abbreviations</a></h1>
<p class="abb_fo">4QJosh<span class="sup_roman">a</span> – <em class="italic">First Joshua Scroll</em> (Dead Sea Scrolls)</p>
<p class="abb_fo">4QSam<span class="sup_roman">a</span> – <em class="italic">First Samuel Scroll</em> (Dead Sea Scrolls)</p>
<p class="abb_fo">AB – Anchor Bible</p>
<p class="abb_fo"><em class="italic">AcT</em> – <em class="italic">Acta Theologica </em></p>
<p class="abb_fo">ANE – ancient Near East</p>
<p class="abb_fo"><em class="italic">Ant.</em> – <em class="italic">Jewish Antiquities</em> (Josephus)</p>
<p class="abb_fo">AOTC – Apollos Old Testament Commentary</p>
<p class="abb_fo"><em class="italic">BBR – Bulletin for Biblical Research </em></p>
<p class="abb_fo"><em class="italic">Bib</em> – <em class="italic">Biblica</em></p>
<p class="abb_fo"><em class="italic">BibInt – Biblical Interpretation</em></p>
<p class="abb_fo"><em class="italic">BibSac – Bibliotheca sacra</em></p>
<p class="abb_fo"><em class="italic">BRev – Bible Review</em></p>
<p class="abb_fo">BST – The Bible Speaks Today</p>
<p class="abb_fo"><em class="italic">BZ – Biblische Zeitschrift</em></p>
<p class="abb_fo">CBC – Cambridge Bible Commentary</p>
<p class="abb_fo"><em class="italic">CBQ – Catholic Biblical Quarterly</em></p>
<p class="abb_fo"><em class="italic">CJT – Concordia Journal of Theology </em></p>
<p class="abb_fo"><span class="smallcaps">esvuk</span> – English Standard Version: Anglicized</p>
<p class="abb_fo"><span class="smallcaps">et</span> – English Translation</p>
<p class="abb_fo">GKC – <em class="italic">Gesenius’ Hebrew Grammar</em>, ed. E. Kautzsch, rev. and tr. A. E. Cowley, Oxford: Clarendon, 1910</p>
<p class="abb_fo"><em class="italic">HBT – Horizons in Biblical Theology </em></p>
<p class="abb_fo">Hebr. – Hebrew</p>
<p class="abb_fo">hi. – hiphil</p>
<p class="abb_fo">ICC – International Critical Commentary</p>
<p class="abb_fo"><em class="italic">Int – Interpretation </em></p>
<p class="abb_fo">ITC – International Theological Commentary</p>
<p class="abb_fo"><em class="italic">JBL</em> – <em class="italic">Journal of Biblical Literature </em></p>
<p class="abb_fo"><em class="italic">JETS</em> – <em class="italic">Journal of the Evangelical Theological Society</em></p>
<p class="abb_fo"><em class="italic">JPT – Journal of Pentecostal Theology</em></p>
<p class="abb_fo"><em class="italic">JSOT</em> – <em class="italic">Journal for the Study of the Old Testament </em></p>
<p class="abb_fo"><span class="smallcaps">mss</span> – manuscripts<em class="italic"> </em></p>
<p class="abb_fo"><span class="smallcaps">mt</span> – Masoretic Text</p>
<p class="abb_fo">NAC – New American Commentary</p>
<p class="abb_fo">NCBC – New Century Bible Commentary</p>
<p class="abb_fo">NICOT – New International Commentary on the Old Testament</p>
<p class="abb_fo"><em class="italic">NIDOTTE</em> – <em class="italic">New International Dictionary of Old Testament Theology and Exegesis</em>, ed. Willem A. VanGemeren, 5 vols., Grand Rapids: Zondervan, 1997</p>
<p class="abb_fo"><span class="smallcaps">niv</span> – New International Version</p>
<p class="abb_fo"><span class="smallcaps">nrsva</span> – New Revised Standard Version: Anglicized</p>
<p class="abb_fo">OT – Old Testament</p>
<p class="abb_fo"><em class="italic">OTE – Old Testament Essays</em></p>
<p class="abb_fo">OTL – Old Testament Library</p>
<p class="abb_fo"><em class="italic">OTS – Oudtestamentische Studiën </em></p>
<p class="abb_fo">PNTC – Pillar New Testament Commentary<em class="italic"> </em></p>
<p class="abb_fo"><em class="italic">RB – Revue biblique </em></p>
<p class="abb_fo"><em class="italic">RevExp – Review and Expositor</em></p>
<p class="abb_fo"><em class="italic">SEÅ</em> – <em class="italic">Svensk Exegetisk Årsbok</em></p>
<p class="abb_fo"><em class="italic">SJOT – Scandinavian Journal of the Old Testament </em></p>
<p class="abb_fo"><em class="italic">STR</em> – <em class="italic">Southeastern Theological Review</em></p>
<p class="abb_fo">TOTC – Tyndale Old Testament Commentary</p>
<p class="abb_fo"><em class="italic">TynB – Tyndale Bulletin</em></p>
<p class="abb_fo"><em class="italic">VT – Vetus Testamentum </em></p>
<p class="abb_fo">WBC – Word Biblical Commentary</p>
<p class="abb_fo">WO – B. K. Waltke and M. O’Connor, <em class="italic">An Introduction to Biblical Hebrew Syntax</em>, Winona Lake: Eisenbrauns, 1990</p>
<p class="abb_fo">yiq. – yiqtol</p>
<p class="abb_fo"><em class="italic">ZAW – Zeitschrift für Alttestamentliche Wissenschaft </em></p>
<p class="fo"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ITS_abbrev.vue?3c88410a